// extracted by mini-css-extract-plugin
module.exports = {"fieldset":"styles__fieldset___1a7hV","legend":"styles__legend___2zlVO","checkbox-wrapper":"styles__checkbox-wrapper___36upi"};